import React from 'react';

const IPTVChannelList = ({ channels, categories, onEdit, onDelete, onReorder }) => {
  const [draggedItem, setDraggedItem] = React.useState(null);

  const handleDragStart = (e, channel) => {
    setDraggedItem(channel);
    e.dataTransfer.effectAllowed = 'move';
  };

  const handleDragOver = (e, index) => {
    e.preventDefault();
    if (!draggedItem) return;

    const draggedIndex = channels.findIndex(c => c.id === draggedItem.id);
    if (draggedIndex === index) return;

    const newChannels = [...channels];
    const [removed] = newChannels.splice(draggedIndex, 1);
    newChannels.splice(index, 0, removed);
    
    onReorder(newChannels);
  };

  const handleDragEnd = () => {
    setDraggedItem(null);
  };

  const getCategoryName = (category) => {
    const cat = categories.find(c => c.category === category);
    return cat ? cat.category : category;
  };

  if (channels.length === 0) {
    return (
      <div className="text-center py-5">
        <i className="fas fa-tv fa-3x text-muted mb-3"></i>
        <p className="text-muted">No channels added yet. Click "Add Channel" to get started.</p>
      </div>
    );
  }

  return (
    <div className="table-responsive">
      <table className="table table-hover">
        <thead>
          <tr>
            <th style={{ width: '40px' }}></th>
            <th>Channel</th>
            <th>Category</th>
            <th>Stream URL</th>
            <th>Status</th>
            <th style={{ width: '120px' }}>Actions</th>
          </tr>
        </thead>
        <tbody>
          {channels.map((channel, index) => (
            <tr
              key={channel.id}
              draggable
              onDragStart={(e) => handleDragStart(e, channel)}
              onDragOver={(e) => handleDragOver(e, index)}
              onDragEnd={handleDragEnd}
              className={draggedItem?.id === channel.id ? 'table-primary' : ''}
              style={{ cursor: 'move' }}
            >
              <td>
                <i className="fas fa-grip-vertical text-muted"></i>
              </td>
              <td>
                <div className="d-flex align-items-center">
                  {channel.logo_url && (
                    <img
                      src={channel.logo_url}
                      alt={channel.name}
                      className="me-2"
                      style={{ width: '40px', height: '40px', objectFit: 'contain' }}
                    />
                  )}
                  <div>
                    <div className="fw-bold">{channel.name}</div>
                    {channel.epg_id && (
                      <small className="text-muted">EPG: {channel.epg_id}</small>
                    )}
                  </div>
                </div>
              </td>
              <td>
                <span className="badge bg-secondary">
                  {getCategoryName(channel.category)}
                </span>
              </td>
              <td>
                <small className="text-muted text-truncate d-inline-block" style={{ maxWidth: '200px' }}>
                  {channel.stream_url}
                </small>
              </td>
              <td>
                <span className={`badge ${channel.is_active ? 'bg-success' : 'bg-warning'}`}>
                  {channel.is_active ? 'Active' : 'Inactive'}
                </span>
              </td>
              <td>
                <div className="btn-group btn-group-sm">
                  <button
                    className="btn btn-outline-primary"
                    onClick={() => onEdit(channel)}
                    title="Edit"
                  >
                    <i className="fas fa-edit"></i>
                  </button>
                  <button
                    className="btn btn-outline-danger"
                    onClick={() => onDelete(channel.id)}
                    title="Delete"
                  >
                    <i className="fas fa-trash"></i>
                  </button>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default IPTVChannelList;
